<template>
  <div class="welDiv">
    <div class="logo">
      <img src="../assets/img/logo.png" alt="" width="73%" />
    </div>
    <div class="desc">
      尊敬的“{{ rowDataObj.full_name }}单位”，<br />
      欢迎使用：
    </div>
    <noticeList :bg="bg" btnText="进入" @viewDetail="viewDetail"></noticeList>
  </div>
</template>

<script>
import noticeList from "../../../components/noticeList";
export default {
  components: {
    noticeList
  },
  data () {
    return {
      bg: [
        {
          img: require("../assets/img/route_bg.png"),
          title: "车辆预约申请",
          color1: "#62E9C5",
          color2: "#3BC69E",
          route: "/rhwxAppointList"
        },
        {
          img: require("../assets/img/information_bg.png"),
          title: "查看单位信息",
          color1: "#AEBCE9",
          color2: "#79A1DA",
          route: "/rhwxInfoDetail"
        },
        {
          img: require("../assets/img/login_bg.png"),
          title: "修改登录密码",
          color1: "#FEC375",
          color2: "#F28E1E",
          route: "/rhwxPwdModify"
        },
        {
          img: require("../assets/img/exit_bg.png"),
          title: "退出登录状态",
          color1: "#88EAE8",
          color2: "#03C3D4",
          route: "/rhwxLogout"
        }
      ],
      rowDataObj: {}
    };
  },
  mounted () {
    this.getDetail();
  },
  methods: {
    // 查看详情
    viewDetail (route) {
      this.$router.push({
        path: route
      });
    },

    // 获取详情
    getDetail () {
      this.$common
        .http({
          url: "/api/supplier/unit_detail"
        })
        .then(res => {
          console.log(res.data.data);
          this.rowDataObj = res.data.data;
        });
    }
  }
};
</script>
<style lang="less">
.welDiv {
  padding: 16px;
  .logo {
    text-align: center;
    padding: 18px 27px 26px;
  }
  .desc {
    font-size: 25px;
    color: #333333;
    letter-spacing: 0.96px;
    line-height: 40px;
    padding-bottom: 6px;
    padding: 0px 17px;
  }
  .btn {
    padding: 22px 0px 30px;
  }
}
</style>
